import * as React from 'react';

export interface Props {
    className?: string;
}
/**
 * This component prevents various events observed by photoswipe to propagate on document element.
 * It is useful when there is custom ui on top of photoswipe and you dont't want photowsipe to react.
 */

class EventBarrier extends React.PureComponent<Props> {
    ref = React.createRef<HTMLDivElement>();

    stopPropagation = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        this.stopNativePropagation(event.nativeEvent);
    }

    stopNativePropagation = (event: Event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
    }

    componentDidMount() {
        if (this.ref.current) {
            this.ref.current.addEventListener('pswpTap', this.stopNativePropagation);
        }
    }

    componentWillUnmount() {
        if (this.ref.current) {
            this.ref.current.removeEventListener('pswpTap', this.stopNativePropagation);
        }
    }

    render() {
        return (
            <div
                ref={this.ref}
                className={this.props.className}
                onPointerMove={this.stopPropagation}
                onPointerCancel={this.stopPropagation}
                onPointerUp={this.stopPropagation}
                onPointerDown={this.stopPropagation}
                onTouchStart={this.stopPropagation}
                onTouchCancel={this.stopPropagation}
                onTouchMove={this.stopPropagation}
                onTouchEnd={this.stopPropagation}
                onMouseUp={this.stopPropagation}
                onMouseMove={this.stopPropagation}
                onMouseDown={this.stopPropagation}
                onKeyDown={this.stopPropagation}
                onKeyUp={this.stopPropagation}
                onKeyPress={this.stopPropagation}
            >
                {this.props.children}
            </div>
        );
    }
}

export default EventBarrier;
